module.exports = __webpack_public_path__ + "f5ac0388775b88a21b588790aa7d080e.png";